import { render, staticRenderFns } from "./contact_type.vue?vue&type=template&id=4e687cf0&scoped=true&"
import script from "./contact_type.vue?vue&type=script&lang=js&"
export * from "./contact_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e687cf0",
  null
  
)

export default component.exports